import { motion } from "framer-motion";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { fmtCard } from "@/lib/api";

export const CardVisual = ({ number }) => {
  const copy = () => { navigator.clipboard?.writeText(number); toast.success("Kart nömrəsi kopyalandı"); };
  return (
    <motion.div whileHover={{ rotateY: -10, rotateX: 6, scale: 1.02 }} style={{ transformPerspective: 1000 }}
      className="relative aspect-[1.586] w-full max-w-md rounded-2xl p-7 overflow-hidden border border-[#D4AF37]/50 shadow-[0_30px_70px_rgba(0,0,0,0.7)]"
      data-testid="deposit-card-visual">
      <div className="absolute inset-0 bg-[#141008]" />
      <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[#D4AF37]/25 blur-3xl" />
      <div className="absolute -bottom-24 -left-10 w-64 h-64 rounded-full bg-[#7B001C]/40 blur-3xl" />
      <div className="relative h-full flex flex-col justify-between">
        <div className="flex justify-between items-start">
          <span className="font-display font-black gold-text text-lg">JACKPOT AZ</span>
          <span className="text-[10px] uppercase tracking-[0.25em] text-zinc-400">Depozit kartı</span>
        </div>
        <div className="w-12 h-9 rounded-md" style={{ background: "linear-gradient(135deg,#fff3b0,#D4AF37,#8a6d12)" }} />
        <div className="flex items-center justify-between gap-3">
          <span className="font-display text-base sm:text-xl tracking-[0.08em] text-white whitespace-nowrap" data-testid="deposit-card-number">{fmtCard(number)}</span>
          <button onClick={copy} type="button" className="btn-ghost rounded-full p-2.5" data-testid="copy-card-btn" aria-label="Kopyala"><Copy size={16} /></button>
        </div>
      </div>
    </motion.div>
  );
};
